<template>
    <div class="card" style="min-height: 300px">
        <div class="table-responsive">
            <table class="table custom-table-padding">
                <thead>
                    <tr>
                        <th>Bill Number</th>
                        <th>Bill Date</th>
                        <th>Customer Name</th>
                        <th>Buyer Name</th>
                        <th>Currency</th>
                        <th>Quotation Ref & Date</th>
                        <th>Order Qty</th>
                        <th>Production Qty</th>
                        <th>Delivered Qty</th>
                        <th>Pending Delivery Qty</th>
                        <th>Ready For Delivery Qty</th>
                        <th>Pending Production Qty</th>
                        <th>Order Value</th>
                        <th>Delivery Value</th>
                        <th>Paid Amount</th>
                        <th>Due Amount</th>
                        <th>Action</th>
                    </tr>
                </thead>
                <tbody>
                <tr v-for="(item, i) in purchase" :key="i">
                    <td> <a @click="goToDetail(item)" href="javascript:void(0)">{{ item.bill_number }}</a></td>
                    <td> {{ item.date }}</td>
                    <td> {{ item.party_name }}</td>
                    <td> {{ item.buyer_name }}</td>
                    <td> {{ item.currency }}</td>
                    <td> {{ item.order_number }}</td>
                    <td> {{ item.total_qty }}</td>
                    <td> {{ item.total_production_qty }}</td>
                    <td> {{ item.delivered_qty }}</td>
                    <td> {{ parseFloat(item.total_qty) - parseFloat(item.delivered_qty) }}</td>
                    <td> {{ parseFloat(item.total_production_qty) - parseFloat(item.delivered_qty) }}</td>
                    <td> {{ parseFloat(item.total_qty) - parseFloat(item.total_production_qty) }}</td>
                    <td> {{ item.bill_amount }}</td>
                    <td> {{ item.delivered_value }}</td>
                    <td> {{ item.paid_amount }}</td>
                    <td> {{ item.due_amount }}</td>
                    <td>
                      <div class="dropdown">
                        <button class="btn btn-secondary btn-sm dropdown-toggle" type="button" data-bs-toggle="dropdown">
                          <i class="fas fa-ellipsis-v"></i>
                        </button>
                        <ul class="dropdown-menu dropdown-menu-end">
                          <li>
                            <a v-if="!item.sale_master_id" @click="goToEdit(item.id)" class="dropdown-item" href="javascript:void(0)">
                              <i class="fas fa-pencil-alt me-2"></i> Edit
                            </a>
                          </li>
                          <li>
                            <a v-if="!item.sale_master_id && !item.challan_master_id && item.status === 'active'"  @click="updateStatus(item.id, 'cancelled')" class="dropdown-item" href="javascript:void(0)">
                              <i class="fa fa-trash"></i> Cancelled Order
                            </a>
                          </li>
                          <li>
                            <a v-if="!item.sale_master_id && !item.challan_master_id && item.status === 'cancelled'"  @click="updateStatus(item.id, 'active')" class="dropdown-item" href="javascript:void(0)">
                              <i class="fa fa-check"></i> Active
                            </a>
                          </li>
                        </ul>
                      </div>
                    </td>
                </tr>

                </tbody>
            </table>
            <p v-if="!purchase.length" class="text-center mt-5">No data</p>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, inject } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import figureFormatter from '@/services/utils/figureFormatter'
import handlePurchase from '@/services/modules/purchase'
import piPdfPrint from '@/services/utils/piPdfPrint'
import handleCompany from '@/services/modules/company'
import handleBarcode from '@/services/modules/barcode'
import { formatDate } from '@/services/utils/global'
import handleHospital from '@/services/modules/hospital'

const props = defineProps({
    purchase: Array,
    route_name: {
        type: String,
        default: 'purchase-bill-edit'
    },
})

const emit = defineEmits(['orderStatusChanged'])

const { commaFormat } = figureFormatter()
const { fetchSalesBill, fetchSalesOrderById, updateOrderStatus } = handlePurchase()
const { fetchCompanyInfo } = handleCompany()
const { exportToPDF } = piPdfPrint()
const { fetchBarcode } = handleBarcode()
const { notesByType } = handleHospital()
const store = useStore()
const $route = useRoute()
const $router = useRouter()
const showError = inject('showError')
const showSuccess = inject('showSuccess')

const companyInfo = ref({})
const invoice = ref({})
const barcodeQuery = ref('')
const barcode = ref('')
const user = ref({})
const qrcode = ref('')
const invoiceNotes = ref([])
const singleSalesOrder = ref({})

function goToDetail(item) {
    const param = {
        companyId: $route.params.companyId,
        moduleId: $route.params.moduleId,
        menuId: $route.params.menuId,
        pageId: $route.params.pageId,
        saleMasterId: item.id
    }
    $router.push({
        name: 'order-production-tracker-detail',
        params: param,
        query: $route.query
    })
}

async function getInvoiceNotes() {
    const companyQuery = `?company_id=${$route.params.companyId}&show_default_only=1`
    await notesByType(companyQuery, 'invoice_terms').then((res) => {
        if (! res.status) return
        invoiceNotes.value = res.data.filter((item) => item.full_desc)
    })
}

async function printPreInvoice(item) {
    const companyQuery = `?company_id=${$route.params.companyId}`
    await fetchSalesOrderById(item.id, companyQuery).then(async (res) => {
        if (! res.data) return

        singleSalesOrder.value = res.data

        const qrcodeData = JSON.stringify({
            ref_no: singleSalesOrder.value.bill_number,
            ref_date: singleSalesOrder.value.date,
            created_by: singleSalesOrder.value.created_by_name,
            created_date_time: formatDate(new Date())
        })

        barcodeQuery.value = `?code=${singleSalesOrder.value.bill_number}&qrcode=${qrcodeData}`

        await fetchBarcode(barcodeQuery.value).then((res) => {
            if (res.status) {
                qrcode.value = res.qrcode
                exportToPDF(companyInfo.value, singleSalesOrder.value, barcode.value, qrcode.value, user.value.name, 1, invoiceNotes.value)
            }
        })
    }).catch((err) => {
    })
}

async function updateStatus(id, status) {
    const actionText = status === 'cancelled' ? 'cancel' : 'activate'
    if (! confirm(`Are you sure you want to ${actionText} this order?`)) return

    const companyQuery = `?company_id=${$route.params.companyId}&status=${status}`

    await updateOrderStatus(companyQuery, id).then((res) => {
        if (! res.status) {
            showError(res.message)
            return
        }
        showSuccess(res.message)
        emit('orderStatusChanged')
    }).catch((err) => {
    })
}

function goToEdit(id) {
    const param = {
        companyId: $route.params.companyId,
        moduleId: $route.params.moduleId,
        menuId: $route.params.menuId,
        pageId: $route.params.pageId,
        salesId: id
    }
    const query = $route.query
    query.type = 'order_production_tracker'
    $router.push({
       name: 'product-sales-order-edit',
       params: param,
       query: query
    })
}

onMounted(() => {
    fetchCompanyInfo($route.params.companyId).then((res) => {
        companyInfo.value = res.data
    }).catch((error) => {
    })

    getInvoiceNotes()

    user.value = store.state.user.user
})
</script>

<style scoped>
.btn-challan {
    background-color: #249024 !important;
}
.custom-table-padding {
    width: 180%
}
.card {
    overflow-x: auto;
}
.table-responsive {
    overflow: visible;
}
:deep(.dropdown-menu.show) {
    z-index: 1060;
}
</style> 